export default {
  columns: {
    offerName: 'Nome offerta',
    type: 'Tipo',
    status: 'Stato',
    active: 'Attivo',
    inactive: 'Inattivo',
    details: 'Dettagli',
    schedule: 'Pianificazione',
    startDate: 'Data di inizio',
    images: 'Immagine',
  },
  actions: {
    edit: 'Modifica',
    rename: 'Rinomina',
    delete: 'Elimina',
    set_active: 'Attiva',
    set_inactive: 'Disattiva',
    cancel: 'Annulla',
    confirm: 'Conferma',
    activate: 'Sostituisci e attiva',
    manage_images: 'Modifica immagine',
  },
  toasts: {
    offer_enabled: "{{offer}} è ora l'offerta attiva per {{for}}",
    offer_disabled: '{{offer}} impostata come inattiva.',
    update_failed: "Aggiornamento dell'offerta non riuscito.",
    successfully_deleted: "L'offerta è stata eliminata con successo",
    delete_failed: "Eliminazione dell'offerta non riuscita",
  },
  title: 'Gestisci tutte le offerte',
  popups: {
    delete: {
      title: 'Sei sicuro di voler eliminare questa offerta?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'La sostituzione delle offerte master non è consentita',
      title: "Sostituire l'offerta attiva per questo periodo?",
      description:
        "Stai attivando {{offer}} il {{weekday}}{{between}}. Questo disattiverà l'offerta attiva corrente {{currentOffer}} per lo stesso periodo.",
      between: ', tra {{start}}-{{end}}',
    },
  },
};
